export default __webpack_public_path__ + "3099d2bd3ce770e8bcc6eae340c32884.svg";